import pageConfig from '../../config/pageConfig';
import { TConfigKey, IConfigOptions } from '../../config/pageConfig/index.d';

export type TPaths = Record<TConfigKey, IConfigOptions['path']>;

export const paths = Object.keys(pageConfig).reduce((obj, key) => {
  obj[key] = pageConfig[key].path;
  return obj;
}, {} as TPaths);
